import { IState } from './state';

export const appSelector = (state: IState) => state.appData;
